/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbRespSearchResultContainer_user = {
    readonly serviceId: string | null;
    readonly " $fragmentRefs": FragmentRefs<"useMeasurementUnit_user" | "SbSharedProductAdWrapper_user">;
    readonly " $refType": "SbRespSearchResultContainer_user";
};
export type SbRespSearchResultContainer_user$data = SbRespSearchResultContainer_user;
export type SbRespSearchResultContainer_user$key = {
    readonly " $data"?: SbRespSearchResultContainer_user$data;
    readonly " $fragmentRefs": FragmentRefs<"SbRespSearchResultContainer_user">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "SbRespSearchResultContainer_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "serviceId",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "InlineDataFragmentSpread",
      "name": "useMeasurementUnit_user",
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "profile",
          "storageKey": null,
          "args": null,
          "concreteType": "Profile",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "measurementUnit",
              "args": null,
              "storageKey": null
            }
          ]
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "SbSharedProductAdWrapper_user",
      "args": null
    }
  ]
};
(node as any).hash = 'd1f42105efda737f8cd60453480c26f6';
export default node;
